import type { AxiosInstance } from 'axios';
import type { ApiPlugin } from '../';

export class LoggerPlugin implements ApiPlugin {
  initialize(instance: AxiosInstance): void {
    const debugMode = !import.meta.env.PROD;

    instance.interceptors.request.use((config) => {
      if (debugMode) {
        // console.log('api request:', config);
      }

      return config;
    });

    instance.interceptors.response.use(
      (response) => {
        if (debugMode) {
          // console.log('api response:', response);
        }

        return response;
      },
      (error) => {
        if (debugMode) {
          // console.log('api error:', error);
        }

        return Promise.reject(error);
      }
    );
  }
}
